export const COMPANY_NAME = "MULECCUL ONLINE"
export const COMPANY_NAME_FULL = "MULECCUL ONLINE"
export const BACKEND_ADDRESS = process.env.REACT_APP_BACKEND_ADDRESS
export const META_TITLE = "MULECCUL ONLINE"
export const META_DESCRIPTION = "Welcome to MULECCUL ONLINE"
export const META_IMAGE = "%PUBLIC_URL%/presentation.png"
export const META_URL = "https://ibanking.muleccul.com"
export const ENABLE_OTHER_DEPOSIT = false
